import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams ,LoadingController,AlertController,ActionSheetController} from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import {GenericFormValidationProvider} from "../../providers/common/form-validation"

/**
 * Generated class for the FaqPostPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-faq-post',
  templateUrl: 'faq-post.html',
})
export class FaqPostPage {
  answer:any="";
  getFaq:any={}
  constructor(public navCtrl: NavController,
   public navParams: NavParams,
   
    private cp: CommonProvider,
    private alertController: AlertController,
    private fv : GenericFormValidationProvider,
    private loadingCtrl: LoadingController,
    private actionSheetCtrl:ActionSheetController) {
  }

  ionViewDidLoad() {
     
    
    this.getFaq = this.navParams.data;
    // //console.log(this.getFaq);
  }
  presentActionSheet(title?:any,msg?:any) {
    const actionSheet = this.actionSheetCtrl.create({
      title: msg,
      cssClass: 'commanSheet',
      buttons: [
        {
          text: "OK",
          role: 'Ok',
          handler: () => {
             actionSheet.dismiss();
          }
        }
      ]
    });
    actionSheet.present();
  }
  postValidationFormSubmit(){
    if(this.answer==""){
    this.presentActionSheet("Error","Select your option");
    return false;
    }else{
       let loading = this.loadingCtrl.create({
                content: 'Please wait...'
              });
       loading.present();
      let body:any={};
    body.ibhfl_happy="303710000";
    body.ibhfl_FAQ = this.getFaq.ibhfl_faqid;
    body.ibhfl_satisficationlevel=this.answer;
    body.ibhfl_remarks="";

     
    // {"ibhfl_happy":"303710000","ibhfl_FAQ":"c55e0d9d-d4bb-e811-a963-000d3af02803",
    // "ibhfl_satisficationlevel":303710003,"ibhfl_remarks":""}
    
     this.cp.postFaq(loading,body).then((res:any)=>{
      loading.dismiss();
      this.presentActionSheet("Success","Thank you for your feedback.");
     })
    }


    
  
  }

}



// WEBPACK FOOTER //
// ./src/pages/faq-post/faq-post.ts